// extracted by mini-css-extract-plugin
export default {"fill-placeholder-child":"fill-placeholder-child_OhDpB","price":"price_oBiQ4"};